import { useEffect, useState } from 'react'
import Service from '../../services/auth'
import Swal from 'sweetalert2'

/**
 * Efeitos que antes viviam no Header (topbar): política de privacidade obrigatória.
 */
const PrivacyBootstrap = () => {
  const [status, setStatus] = useState(
    localStorage.getItem('privacy_and_terms')
  )

  const loadPrivacy = async () => {
    const privacy = await Service.loadPrivacy()
    if (privacy.status === 200) {
      localStorage.setItem(
        'privacy_and_terms',
        privacy.data.data.privacy_and_terms
      )
      setStatus(privacy.data.data.privacy_and_terms)
    }
  }

  useEffect(() => {
    loadPrivacy()
  }, [])

  useEffect(() => {
    if (!status && window.location.pathname !== '/politica-de-privacidade') {
      Swal.fire({
        title: 'Política de Privacidade',
        text: 'Você precisa aceitar as políticas de privacidade para continuar. Clique no botão abaixo para ler e aceitar.',
        icon: 'warning',
        confirmButtonText: 'Ler Políticas',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/politica-de-privacidade'
        }
      })
    }
  }, [status])

  return null
}

export default PrivacyBootstrap
